/*
 src/reducers/rootReducer.js
*/

import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { verification } from "./verification.reducer";
import {
  resendTokenFromLogin,
  resendTokenFromExpiredToken,
} from "./resendVerifyToken.reducer";
import { metadata } from "./metadata.reducer";
import { cpmReducer } from "./cpm.reducer";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    verification,
    resendTokenFromLogin,
    resendTokenFromExpiredToken,
    metadata,
    cpm: cpmReducer,
  });
